export default __webpack_public_path__ + "static/equilibre_avatar_beate_thormeier-47cd4070c92c03cc4b31bb85607e3613.png";